export default __webpack_public_path__ + "static/pic3-699f2e5fcf079ea546a21c35fcbac7cc.png";